import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import HomeIcon from '@mui/icons-material/Home';
import EditIcon from '@mui/icons-material/Edit';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import Person4Icon from '@mui/icons-material/Person4';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { ProductContext } from '../context/AppContext';
import "../index.css";
import Footer from './Common_Components/Footer';

const LearningQuizResult = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [activePage, setActivePage] = useState("Learning");
    const { correctCount, incorrectCount, skippedCount, resetQuizData } = useContext(ProductContext);
    const categoryData = location.state;
    const category_id = categoryData?.category_id;
    const level_id = categoryData?.level_id;
    const categoryName = categoryData?.categoryName; // Rename for consistency
    const total_time_spent = categoryData?.total_time_spent;
    // const { category_id, level_id, categoryName, total_time_spent } = QuizResult;
    const [isLoading, setIsLoading] = useState(false);
    const [attempts, setAttempts] = useState({
        correct: correctCount,
        incorrect: incorrectCount,
        skipped: skippedCount,
    });
    console.log("Recived Quiz Result Details:", category_id, level_id, categoryName, total_time_spent);
    const { Translate } = useContext(ProductContext);
    const { quizTypeId, quizName } = location.state || {};

    console.log(quizTypeId, "quizTypeId LearningQuizResult")
    console.log(quizName, "quizName LearningQuizResult")

    const [correctAttempts, setCorrectAttempts] = useState(0);
    const [incorrectAttempts, setIncorrectAttempts] = useState(0);
    const [unAttempts, setUnAttempts] = useState(0);
    useEffect(() => {
        setAttempts({
            correct: correctCount,
            incorrect: incorrectCount,
            skipped: skippedCount,
        });
    }, [correctCount, incorrectCount, skippedCount]);
    useEffect(() => {
        setCorrectAttempts(correctCount);
        setIncorrectAttempts(incorrectCount);
        setUnAttempts(skippedCount);
    }, [correctCount, incorrectCount, skippedCount]);
    // useEffect(
    //     React.useCallback(() => {
    //       return () => {
    //         resetQuizData();
    //       };
    //     }, [resetQuizData]),
    //   );
    const handleNextSet = () => {
        setIsLoading(true);
        setTimeout(() => {
            resetQuizData();
            navigate('/take-quiz', {
                state: {
                    category_id,
                    level_id,
                    total_time_spent,
                    categoryName,
                    currentSet: true
                },
            });

            setIsLoading(false);
        }, 1000);
    };
    

    const totalAttempts = attempts.correct + attempts.incorrect + attempts.skipped;
    const correctPercentage = totalAttempts > 0 ? (attempts.correct / totalAttempts) * 100 : 0;
    const incorrectPercentage = totalAttempts > 0 ? (attempts.incorrect / totalAttempts) * 100 : 0;
    const skippedPercentage = totalAttempts > 0 ? (attempts.skipped / totalAttempts) * 100 : 0;
    const [selectedLanguage, setSelectedLanguage] = useState('');
    const SelectLanguageLocal = localStorage.getItem("selectedLanguage");

    console.log(SelectLanguageLocal, "SelectLanguageLocal")
    useEffect(() => {
        const loadLanguage = async () => {
            try {
                const storedLanguage = localStorage.getItem("selectedLanguage");
                console.log("storedLanguage", storedLanguage);
                if (storedLanguage) {
                    setSelectedLanguage(storedLanguage);
                }
            } catch (error) {
                console.error("Error loading language:", error);
            }
        };

        loadLanguage();
    }, []);
    return (
        <div className='Profile_Design_Main_Div_11'>
            <div className='header_inner'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <ArrowBackIosIcon onClick={() => navigate(-1)} className='icon_1' />

                            <h2>{Translate?.message?.data?.quizResults || "Quiz Results for"} {categoryName}</h2>

                            <ChatBubbleOutlineIcon onClick={() => navigate('/chat-with-staff')} className="logo_1" style={{ cursor: 'pointer', color: '#ffc0cb' }} />
                        </div>
                    </div>
                </div>
            </div>

            <div className="container JLPT_Quiz" style={{ marginTop: "85px", marginBottom: "75px", height: "470px" }}>
                <div className='progressWrapper'>
                    {/* Nested Progress Circles */}
                    <Box sx={{ position: 'relative', display: 'inline-flex', margin: '20px' }}>
                        {/* Correct Percentage */}
                        <CircularProgress
                            variant="determinate"
                            value={correctPercentage} // Shows correct percentage
                            style={{
                                width: '180px',
                                height: '180px',
                                zIndex: 2,
                            }}
                            sx={{
                                color: correctPercentage > 0 ? '#4CAF50' : '#E0E0E0', // Green for correct, light grey otherwise
                            }}
                        />
                        {/* Background Circle for Correct */}
                        <CircularProgress
                            variant="determinate"
                            value={100}
                            style={{
                                width: '180px',
                                height: '180px',
                                position: 'absolute',
                                zIndex: 1,
                            }}
                            sx={{
                                color: '#ffc0cb', // Background color (light grey)
                            }}
                        />

                        {/* Incorrect Percentage */}
                        <Box sx={{ position: 'absolute', top: '20px', left: '20px' }}>
                            <CircularProgress
                                variant="determinate"
                                value={incorrectPercentage} // Shows incorrect percentage
                                style={{
                                    width: '140px',
                                    height: '140px',
                                    position: 'absolute',  // Position absolutely within the container
                                    top: 0,
                                    left: 0,
                                    zIndex: 2,
                                }}
                                sx={{
                                    color: incorrectPercentage > 0 ? '#F44336' : '#E0E0E0', // Red for incorrect, light grey otherwise
                                }}
                            />
                            {/* Background Circle for Incorrect */}
                            <CircularProgress
                                variant="determinate"
                                value={100}
                                style={{
                                    position: 'absolute',
                                    width: '140px',
                                    height: '140px',
                                    top: 0,
                                    left: 0,
                                    zIndex: 1,
                                }}
                                sx={{
                                    color: '#ffc0cb', // Background color (light grey)
                                }}
                            />
                        </Box>

                        {/* Skipped Percentage */}
                        <Box sx={{ position: 'absolute', top: '40px', left: '40px' }}>
                            <div style={{
                                position: 'relative',
                                width: '100px',
                                height: '100px',
                            }}>
                                {/* Skipped Percentage Circle */}
                                <CircularProgress
                                    variant="determinate"
                                    value={skippedPercentage}
                                    style={{
                                        width: '100px',
                                        height: '100px',
                                        position: 'absolute',  // Position absolutely within the container
                                        top: 0,
                                        left: 0,
                                        zIndex: 2,  // Make sure this is above the background circle
                                    }}
                                    sx={{
                                        color: skippedPercentage > 0 ? 'gray' : 'gray', // Grey for skipped, light grey otherwise
                                    }}
                                />

                                {/* Background Circle for Skipped */}
                                <CircularProgress
                                    variant="determinate"
                                    value={100}
                                    style={{
                                        position: 'absolute',
                                        width: '100px',
                                        height: '100px',
                                        top: 0,
                                        left: 0,
                                        zIndex: 1,  // This will be behind the skipped percentage circle
                                    }}
                                    sx={{
                                        color: '#ffc0cb', // Background color (light grey)
                                    }}
                                />
                            </div>



                        </Box>
                    </Box>
                </div>

                {/* Result Details */}
                <div className="resultDetails">
                    <div className="quiz-result-menu-item">
                        <span className="quiz-result-menu-text">{Translate?.message?.data?.correct || "Correct"}</span>
                        <span className="quiz-result-menu-number">{correctAttempts}</span>
                    </div>
                    <div className="quiz-result-menu-item">

                        <span className="quiz-result-menu-text">{Translate?.message?.data?.incorrect || "Incorrect"}</span>

                        <span className="quiz-result-menu-number">{incorrectAttempts}</span>
                    </div>
                    <div className="quiz-result-menu-item">
                        <span className="quiz-result-menu-text">{Translate?.message?.data?.skipped || "Skipped"}</span>
                        <span className="quiz-result-menu-number">{unAttempts}</span>
                    </div>
                </div>

                {/* Buttons */}
                <div className='buttonContainer'>

                    <button 
                    onClick={() => {
                            resetQuizData();
                            navigate('/JLPTQuiz', {
                                state: {
                                    category_id,
                                    level_id,
                                    total_time_spent,
                                    categoryName,
                                    loadNextSet: true,
                                    quizTypeId,
                                    quizName
                                },
                            });
                        }} className="Quiz-Result-action-button">
                        {Translate?.message?.data?.Return || "Return"}
                    </button>
                    <button
                        onClick={() => {
                            resetQuizData();
                            navigate('/ReadingQuiz', {
                                state: {
                                    category_id,
                                    level_id,
                                    total_time_spent,
                                    categoryName,
                                    loadNextSet: true,
                                    quizTypeId,
                                    quizName
                                },
                            });
                        }}
                        className="Quiz-Result-action-button"
                    >
                        {Translate?.message?.data?.moveToNext || "Move to Next"}
                    </button>

                </div>
            </div>

            {/* Footer Section */}
      <Footer />
    </div>
  );
};

export default LearningQuizResult;